import React, {Component} from "react";
import {Fragment} from "react";
import offImage from './images/off.png';
import Loading from "./loader";
import QuestionNavigator from "./QuestionNavigator";
import ScrollUpButton from "react-scroll-up-button";
import { ArrowLeftOutlined } from "@ant-design/icons";
import StateWarning from './StateWarning';

class VoteAgendaPreShow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        detailsVisible: [],
        mainMeeting: [],
        agenda: [],
        questionDetail: {},
        voteCount: [],
        isLoading: true,
        inputValues: {},
        votes: {},
        votesMap: {},
        detailsMap: {},
        emptyVotes: false,
        showScrollUp: false, // Отслеживание видимости кнопки "Наверх"
        isOverlapped: false,
        labelsLeft: 0,
        columnWidths: [80, 80, 80]
        };

        this.processVoteCount = this.processVoteCount.bind(this);
    }

    processVoteCount(voteCount) {
        const votesResult = {};
        if (Array.isArray(voteCount)) {
            voteCount.forEach(item => {
                if (item?.json_quantity?.VoteDtls?.VoteInstrForAgndRsltn) {
                    item.json_quantity.VoteDtls.VoteInstrForAgndRsltn.forEach(vote => {
                        const { Quantity, DetailId, QuestionId } = vote.VoteInstr;
                        if (!votesResult[QuestionId]) {
                            votesResult[QuestionId] = {};
                        }
                        votesResult[QuestionId][DetailId] = [vote.VoteInstr.Vote, Quantity];
                    });
                }
            });
        }
        return votesResult;
    }

    processVotesData(resData) {
        const votes = {};
        const inputValues = {};

        if (resData[0]?.json_result?.VoteDtls?.VoteInstrForAgndRsltn) {
            resData[0].json_result.VoteDtls.VoteInstrForAgndRsltn.forEach(item => {
                const { QuestionId, DetailId, For, Against, Abstn } = item.VoteInstr;

                if (!votes[QuestionId]) {
                    votes[QuestionId] = {};
                }

                const processVote = (voteType) => {
                    if (voteType) {
                        const { Quantity, Numerator, Denominator } = voteType;
                        if (Numerator !== undefined && Denominator !== undefined) {
                            if (Quantity !== undefined) {
                                // Смешанное число
                                return `${Quantity} ${Numerator}/${Denominator}`;
                            } else {
                                // Дробное число
                                return `${Numerator}/${Denominator}`;
                            }
                        } else if (Quantity !== undefined) {
                            // Целое число
                            return Quantity;
                        }
                    }
                    return null;
                };

                if (DetailId) {
                    // Если есть DetailId, это дополнительный вопрос
                    if (For) {
                        votes[QuestionId][DetailId] = ['За', processVote(For)];
                    } else if (Against) {
                        votes[QuestionId][DetailId] = ['Против', processVote(Against)];
                    } else if (Abstn) {
                        votes[QuestionId][DetailId] = ['Воздержался', processVote(Abstn)];
                    }
                } else {
                    // Если нет DetailId, это обычный вопрос
                    if (For) {
                        votes[QuestionId] = ['За', processVote(For)];
                    } else if (Against) {
                        votes[QuestionId] = ['Против', processVote(Against)];
                    } else if (Abstn) {
                        votes[QuestionId] = ['Воздержался', processVote(Abstn)];
                    }
                }

                // Обработка кумулятивных вопросов
                if (DetailId && this.isCumulativeQuestion(QuestionId)) {
                    if (!inputValues[QuestionId]) {
                        inputValues[QuestionId] = {};
                    }
                    if (For) {
                        inputValues[QuestionId][DetailId] = processVote(For);
                    } else if (Against) {
                        inputValues[QuestionId][DetailId] = processVote(Against);
                    } else if (Abstn) {
                        inputValues[QuestionId][DetailId] = processVote(Abstn);
                    }
                }
            });
        } else {
            this.setState({ emptyVotes: true });
        }
        return { votes, inputValues };
    }

    // Вспомогательная функция для определения, является ли вопрос кумулятивным
    isCumulativeQuestion(questionId) {
        const { agenda } = this.state;

        if (!agenda || agenda.length === 0) {
            console.error('Ошибка: agenda не загружена или пуста');
            return false;
        }

        const question = agenda.find(item => item.question_id === questionId);
        return question?.cumulative || false;
    }

    handleInputChange(questionId, detailId, event) {
        const { inputValues } = this.state;
        const value = event.target.value;

        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [questionId]: {
                    ...prevState.inputValues[questionId],
                    [detailId]: value,
                },
            },
        }), () => {});
    }

    async componentDidMount() {
        const { match, is_staff, is_superuser } = this.props;
        const meetingId = match.params.meetingId;
        const selectedAccountId = '0';
        const selectedUniquifier = '0';
        window.addEventListener('scroll', this.handleScroll);

        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const userRes = await fetch(`${API_ADDRESS}get_vote_anketa_admin_show/${meetingId}/${selectedAccountId}/${selectedUniquifier}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        if (userRes.ok) {
            const AnketaData = await userRes.json();
            if (!AnketaData.agenda || AnketaData.agenda.length === 0) {
                this.setState({ isLoading: false });
                return;
            }

            this.setState({ agenda: AnketaData.agenda }, () => {
                const sortedAgenda = [...AnketaData.agenda].sort((a, b) =>
                    parseInt(a.question_id, 10) - parseInt(b.question_id, 10)
                );
                this.setState({
                    mainMeeting: AnketaData.mainMeeting,
                    isLoading: false,
                    agenda: sortedAgenda,
                    votes: {},
                    inputValues: {},
                    voteCount: [],
                    emptyVotes: false,
                }, () => {
                    this.setupObserver();
                    this.updateColumnWidths();
                    window.addEventListener('resize', this.updateColumnWidths);
                });
            });
        } else {
            this.setState({ isLoading: false });
            alert("Произошла ошибка. Попробуйте еще раз.");
            window.history.back();
        }

        if (userRes["statusText"] === "Unauthorized") {
            alert("Время сессии истекло. Пожалуйста, выполните вход.");
            document.getElementById("logoutBttn").click();
        }
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;

        if (prevProps.is_staff !== is_staff || prevProps.is_superuser !== is_superuser) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.observer) {
            this.observer.disconnect();
        }
        window.removeEventListener('resize', this.updateColumnWidths);
    }

    setTableAnchorRef = (element) => {
      this.tableAnchorRef = element;
    };

    getCumulativeCount = (questionId) => {
        return '-';
    };

    toggleDetail = async (questionId) => {
       const { detailsVisible } = this.state;
       const currentlyVisible = detailsVisible[questionId];

       this.setState(prevState => ({
           detailsVisible: {
               ...prevState.detailsVisible,
               [questionId]: !currentlyVisible
           },
           loading: true, // установка состояния загрузки
       }));

       if (!currentlyVisible) {
           const { match } = this.props;
           const meetingId = match.params.meetingId;
           const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

           try {
               const response = await fetch(`${API_ADDRESS}get_cumulatives/${meetingId}/${questionId}/`, {
                   headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`,
                   },
               });

               if (response.ok) {
                   const questionsData = await response.json();

                   const sortedQuestionDetail = [...questionsData.questionDetail].sort(
                        (a, b) => a.detail_id - b.detail_id
                    );

                   this.setState(prevState => ({
                        questionDetail: {
                            ...prevState.questionDetail,
                            [questionId]: sortedQuestionDetail,
                        },
                        loading: false,
                    }));
               }
           } catch (e) {
               console.error(e);
               this.setState({ loading: false }); // сброс состояния загрузки в случае ошибки
           }
       } else {
           this.setState({ loading: false }); // сброс состояния загрузки если детали уже загружены
       }
   };

    handleBackButton = () => {
        window.history.back();
    };

    highlightRow = (questionId) => {
        const row = document.getElementById(`question-${questionId}`);
        if (row) {
            row.classList.add('blink-animation');

            setTimeout(() => {
                row.classList.remove('blink-animation');
            }, 1000);
        }
    };

    handleScroll = () => {
        const showScrollUp = window.scrollY > 130;
        this.setState({ showScrollUp });
    };

    // Обработчик для отслеживания пересечения области просмотра
    setupObserver = () => {
      if (!this.tableAnchorRef) {
        return;
      }

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry) return;
          this.setState({ isOverlapped: !entry.isIntersecting });
        },
        {
          threshold: 0,
          rootMargin: '-80px 0px 0px 0px',
        }
      );

      this.observer.observe(this.tableAnchorRef);
    };

    updateColumnWidths = () => {
      const headers = document.querySelectorAll('.table-checkbox thead th.checkbox-column');
      if (headers.length === 3) {
        const rects = Array.from(headers).map(el => el.getBoundingClientRect());

        this.setState({
          columnWidths: rects.map(r => r.width),
          labelsLeft: rects[0].left,
        });
      }
    };

    render() {
    const { mainMeeting, agenda, questionDetail, voteCount, detailsVisible, isLoading, emptyVotes } = this.state;
    if (isLoading) {
        return <Loading />;
    }

    if (emptyVotes) {
        return (
            <div style={{marginTop: '40px'}}>
                <StateWarning message="Результаты голосования отсутствуют" />
                <div className="button-container5">
                    <button2 className="button2" style={{ margin: '0 auto' }} onClick={this.handleBackButton}>
                        <b>Назад</b>
                    </button2>
                </div>
            </div>
        );
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
        const formattedDate = date.toLocaleString('ru-RU', options);
        return formattedDate.replace(/ GMT.*/, '').replace(' года', '').trim();
    };

    return (
        <>
            <div className="page-container">
                <div className="header-container">
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                        <div className="back-button-wrapper" onClick={this.handleBackButton}>
                            <ArrowLeftOutlined
                                style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                            />
                        </div>
                        <h1>Предпросмотр бюллетеня</h1>
                    </div>
                </div>

                <div className="grid-container2">
                    <p style={{textAlign: 'center'}}><b>{mainMeeting.meeting_name}</b></p>
                    <p style={{textAlign: 'center', marginTop: '0'}}><b>Акционерное общество "Ведение реестров
                        компаний"</b>
                    </p>

                    <div className="rightContent"></div>

                    <div className="row1">
                        <label htmlFor="endDate">Дата, время окончания приёма бюллетеней:</label>
                        <span className="whiteBox"><b>{formatDate(mainMeeting.deadline_date)} мск</b></span>
                    </div>

                    <span
                        ref={this.setTableAnchorRef}
                        style={{display: 'inline-block', width: 0, height: 1}}
                    />
                    <table className="table-checkbox">
                        <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th className="checkbox-column">За</th>
                            <th className="checkbox-column">Против</th>
                            <th className="checkbox-column">Воздержался</th>
                        </tr>
                        </thead>
                        <tbody>
                        {agenda.map((item, index) => (
                            <React.Fragment key={item.question_id}>
                                <tr id={`question-${item.question_id}`}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <div style={{
                                            marginTop: '10px',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center'
                                        }}>
                                            {item.cumulative && (
                                                <div
                                                    style={{display: 'flex', alignItems: 'center', textAlign: 'right'}}>
                                                    <span>Количество кумулятивных голосов: </span>
                                                    <span className="greyBox" style={{marginLeft: '5px'}}>
                                                        <b>{this.getCumulativeCount(item.question_id)}</b>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{marginTop: '15px'}}>
                                            <i><b>Вопрос:</b></i> {item.question}
                                        </div>
                                        <div style={{marginTop: '10px'}}>
                                            <i><b>Решение:</b></i> {item.decision}
                                        </div>
                                        {(item.cumulative || (item.cumulative === false && item.seat_count > 0)) && (
                                            <img
                                                src={offImage}
                                                alt={detailsVisible[item.question_id] ? 'Скрыть' : 'Развернуть'}
                                                onClick={() => this.toggleDetail(item.question_id)}
                                                className={`toggle-icon ${detailsVisible[item.question_id] ? 'rotated' : ''}`}
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                            />
                                        )} <br/>
                                    </td>
                                    <td className="checkbox-column">
                                        {item.cumulative ? null : (
                                            <input
                                                type="checkbox"
                                                checked={false}
                                                onClick={e => e.preventDefault()}
                                                disabled={(item.cumulative === false && item.seat_count > 0)}
                                            />
                                        )}
                                    </td>
                                    <td className="checkbox-column">
                                        <input
                                            type="checkbox"
                                            checked={false}
                                            onClick={e => e.preventDefault()}
                                            disabled={(item.cumulative === false && item.seat_count > 0)}
                                        />
                                    </td>
                                    <td className="checkbox-column">
                                        <input
                                            type="checkbox"
                                            checked={false}
                                            onClick={e => e.preventDefault()}
                                            disabled={(item.cumulative === false && item.seat_count > 0)}
                                        />
                                    </td>
                                </tr>
                                {item.cumulative && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                                    questionDetail[item.question_id].map((detail, detailIndex) => (
                                        <tr key={detailIndex}>
                                            <td></td>
                                            <td style={{paddingLeft: '100px'}}>
                                                {detail.detail_text}
                                            </td>
                                            <td className="checkbox-column">
                                                <input
                                                    type="text"
                                                    className="main-input7"
                                                    value={this.state.inputValues[item.question_id]?.[detail.detail_id] || ''}
                                                    onChange={(e) => this.handleInputChange(item.question_id, detail.detail_id, e)}
                                                    disabled={(this.state.votes[item.question_id]?.[0] === 'Против' ||
                                                        this.state.votes[item.question_id]?.[0] === 'Воздержался') && item.cumulative}
                                                    readOnly
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                                {item.cumulative === false && item.seat_count > 0 && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                                    questionDetail[item.question_id].map((detail, detailIndex) => (
                                        <tr key={detailIndex}>
                                            <td></td>
                                            <td style={{paddingLeft: '100px'}}>
                                                {detail.detail_text}
                                            </td>
                                            <td className="checkbox-column">
                                                <input
                                                    type="checkbox"
                                                    checked={false}
                                                    onClick={e => e.preventDefault()}
                                                />
                                            </td>
                                            <td className="checkbox-column">
                                                <input
                                                    type="checkbox"
                                                    checked={false}
                                                    onClick={e => e.preventDefault()}
                                                />
                                            </td>
                                            <td className="checkbox-column">
                                                <input
                                                    type="checkbox"
                                                    checked={false}
                                                    onClick={e => e.preventDefault()}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                    <QuestionNavigator
                        questions={this.state.agenda.map(q => ({
                            ...q,
                            question_id: q.question_id
                        }))}
                        onQuestionClick={this.highlightRow}
                        showScrollUp={this.state.showScrollUp}
                    />
                    <div className="button-container5">
                        <button2 className="button2"
                                 style={{margin: '0 auto'}}
                                 onClick={this.handleBackButton}>
                            <b>Назад</b>
                        </button2>
                    </div>
                    <div>
                        <ScrollUpButton/>
                    </div>
                    {this.state.isOverlapped && (
                        <div className="floating-labels">
                            {/* За */}
                            <div
                                className="floating-label show"
                                style={{
                                    width: `${this.state.columnWidths[0] - 10}px`,
                                    left: `${this.state.labelsLeft + 5}px`,
                                }}
                            >
                                За
                            </div>

                            {/* Против */}
                            <div
                                className="floating-label show"
                                style={{
                                    width: `${this.state.columnWidths[1] - 10}px`,
                                    left: `${this.state.labelsLeft + this.state.columnWidths[0] + 5}px`,
                                }}
                            >
                                Против
                            </div>

                            {/* Воздержался */}
                            <div
                                className="floating-label show"
                                style={{
                                    width: `${this.state.columnWidths[2] - 10}px`,
                                    left: `${
                                        this.state.labelsLeft +
                                        this.state.columnWidths[0] +
                                        this.state.columnWidths[1] +
                                        5
                                    }px`,
                                }}
                            >
                                Воздержался
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
    }
}

export default VoteAgendaPreShow;
